import React, { createContext } from 'react'
import { useState } from 'react'

const SignContext = createContext()

export const SignProvider = ({ children }) => {
    const [loginPopup, setLoginPopup] = useState(false)
    const [registerPopup, setRegisterPopup] = useState(false)
    const [forgotPasswordPopup, setForgotPasswordPopup] = useState(false)
    const [filterDateRangeModal, setFilterDateRangeModal] = useState(false)
    const handleLoginPopup = () => {
        setLoginPopup(!loginPopup)
        setRegisterPopup(false)
    }
    const handleRegisterPopup = () => {
        setRegisterPopup(!registerPopup)
        setLoginPopup(false)
    }
    const handleForgotPasswordPopup = () => {
        setForgotPasswordPopup(!forgotPasswordPopup)
        setLoginPopup(false)
        setRegisterPopup(false)
    }
    const hanldeShowFilterViewModal = () => {
        setFilterDateRangeModal(!filterDateRangeModal)
    }
    return (
        <SignContext.Provider
            value={{
                loginPopup,
                handleLoginPopup,
                registerPopup,
                filterDateRangeModal,
                setRegisterPopup,
                handleRegisterPopup,
                setLoginPopup,
                setForgotPasswordPopup,
                handleForgotPasswordPopup,
                hanldeShowFilterViewModal,
                forgotPasswordPopup,
            }}
        >
            {children}
        </SignContext.Provider>
    )
}

export default SignContext
